<template>
  <AccountProfessional :professionalId="professionalId"></AccountProfessional>
</template>
<script>
import AccountProfessional from "../../../components/account/Professional";
import { xray } from "../../../config/pluginInit";
import utilsService from "../../../services/utils";

export default {
  name: "Account",
  mounted() {
    xray.index();
    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_MY_ACCOUNT", info: "" });
  },
  components: { AccountProfessional },
  data() {
    return {
      professionalId: localStorage.getItem("userId"),
    };
  },
  methods: {},
  computed: {},
};
</script>
